import { styled } from "@mui/material";

export const Bold = styled("span")(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));
